<template>

    <Tabs value="0">

        <TabList>
            <Tab value="0">
                <i class="fa fa-info-circle me-2"></i>
                <span>{{TR.info}}</span>
            </Tab>
            <Tab value="1">
                <i class="fas fa-filter me-2"></i>
                <span>{{TR.filters}}</span>
            </Tab>
        </TabList>

        <TabPanels>
            <TabPanel value="0">
                <DynamicTable2 v-bind:mainref="mainref" :data="data" />
            </TabPanel>

            <TabPanel value="1">
                <div class="filter_list mt-1 text-center">
                    <button class="btn btn-success mb-3" @click="addNewFilter()"><i class="fas fa-plus me-1"></i> {{ TR.filter + ' ' + TR.add }} </button>

                    <draggable
                        tag="ul"
                        :list="PO['newdata']['group_filters']"
                        class="list-group"
                        item-key="id"
                        handle=".handle"
                        ghost-class="draggable-ghost"
                        @end="onEnd"
                    >
                        <template #header>
                            <div class="row bg-light text-center1 m-0 p-2 border text-center">
                                <div class="col-1">{{ TR.move }}</div>
                                <div class="col-1">{{ TR.id }}</div>
                                <div class="col-1">{{ TR.remove }}</div>
                                <div class="col-7">{{ TR.name }}</div>
                                <div class="col-2">{{ TR.rank }}</div>
                            </div>
                        </template>

                        <template #item="{element}">
                            <div class="draggable-item list-group-item">

                                <div class="row d-flex align-items-center m-0">
                                    <div class="col-12 col-sm-1">
                                        <i class="fas fa-arrows-alt p-2 pe-4 handle cursor-pointer"></i>
                                    </div>
                                    <div class="col-12 col-sm-1">
                                        {{ element.id }}
                                    </div>
                                    <div class="col-12 col-sm-1">
                                        <button
                                            class="btn btn-danger"
                                            @click="removeNewFilter(element.id)"
                                        >
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </div>
                                    <div class="col-12 col-sm-7">
                                        <div class="d-flex flex-row align-items-center" v-for="li in G.lang_list" :key="li.value">
                                            <span class="me-2">{{ li.flag }}</span>
                                            <input type="text" :placeholder="TR.filter + ' ' + TR.name" v-model="element.name[li.value]" class="form-control me-2" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-2">
                                        <InputNumber
                                            v-model="element.rank"
                                            :placeholder="TR.rank"
                                            :useGrouping="false"
                                            :inputStyle="{width: '8rem'}"
                                            @click.stop.prevent
                                            :min="1"
                                            :max="1000"
                                            integeronly
                                        />
                                    </div>
                                </div>

                            </div>
                        </template>
                </draggable>

                    <!-- <table v-if="PO['newdata']['group_filters']" class="table table-striped">
                        <tbody>
                            <tr v-for="(item, index) in PO['newdata']['group_filters']" :key="index">
                                <td class="align-middle">{{ index + 1 }}</td>
                                <td class="align-middle">
                                    <div class="d-flex flex-row align-items-center" v-for="li in G.lang_list" :key="li.value">
                                        <span class="me-2">{{ li.flag }}</span>
                                        <input type="text" :placeholder="TR.filter + ' ' + TR.name" v-model="PO['newdata']['group_filters'][index]['name'][li.value]" class="form-control me-2" />
                                    </div>
                                </td>
                                <td class="align-middle">
                                    <InputNumber
                                        v-model="PO['newdata']['group_filters'][index]['rank']"
                                        :min="1"
                                        :placeholder="TR.rank"
                                        integeronly
                                        :useGrouping="false"
                                        @click.stop.prevent
                                        :inputStyle="{width: '8rem'}"
                                        :max="1000"
                                    />
                                    <button class="btn btn-danger ms-2" @click="removeNewFilter(item.id)"><i class="fas fa-trash"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table> -->

                </div>
            </TabPanel>
        </TabPanels>

    </Tabs>

</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";

    import { useStore } from '@/system_modules/store';

    import { G, ajax } from "@/_common";

    import draggable from 'vuedraggable';

    import { useModelWrapper } from "@/system_modules/utils/modelWrapper";

    import Tabs from 'primevue/tabs';
    import TabList from 'primevue/tablist';
    import Tab from 'primevue/tab';
    import TabPanels from 'primevue/tabpanels';
    import TabPanel from 'primevue/tabpanel';
    import InputNumber from "primevue/inputnumber";

    import DynamicTable2 from "@/components/table/DynamicTable2";

    export default {
        name: 'FilterInfoP',
        props: {
            data: {
                type: Object,
                default(){
                    return {};
                }
            },
            mainref: {
                type: Object,
                defeault(){
                    return {};
                }
            },
        },
        components: {
            Tabs,
            TabList,
            Tab,
            TabPanels,
            TabPanel,
            InputNumber,
            DynamicTable2,
            draggable,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref({});
            const PO = useModelWrapper(props, emit, "mainref");

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            const onEnd = () => {
                PO.value['newdata']["group_filters"].forEach((e, i)=>{
                    e.rank = i + 1;
                });
            };

            const addNewFilter = () => {
                let nm = {};
                G.lang_list.forEach((l) => { nm[l.value] = (l.value == 1 ? "filter 1" : ""); });
                let new_rank = PO.value['newdata']["group_filters"].length+1;
                let idn = new_rank*-1;
                PO.value['newdata']['group_filters'].push({id: idn, name: nm, rank: new_rank});
            };

            const removeNewFilter = (ind) => {
                PO.value['newdata']['group_filters'].forEach((a, i) => {
                    if( a.id == ind )
                        PO.value['newdata']['group_filters'].splice(i, 1);
                });
            };

            const removeFilter = (filter_id, image_id) => {
                G.alert.confirm({ type: 'error', title: TR.value.warning, msg: TR.value.msg_remove_question, yesTitle: TR.value.yes, yes: async () => {
                    await ajax({
                        url: store.getFilterGroupFilterRemove(filter_id),
                        method: 'delete',
                        content_type: 'application/json; charset=UTF-8',
                        data: [image_id],
                        success: (e) => {
                            const res = e.data || null;
                            G.alert.success(res.detail.title);
                        },
                    });
                }, noTitle: TR.value.no, no: () => {} })
            };

            onMounted(async () => {
                if( PO.value['newdata'] === undefined ){
                    PO.value['newdata'] = [];
                }

                if( PO.value['newdata']['group_filters'] === undefined || props.data.data.group_filters === undefined ){
                    PO.value['newdata']['group_filters'] = [];
                }
                if( props.data.data.group_filters !== undefined ){
                    props.data.data.group_filters.forEach((e) => {
                        let nm = {};
                        e.translate.forEach((t) => (nm[t.lang_id] = t.name));
                        PO.value['newdata']['group_filters'].push({id: e.id, name: nm, rank: e.rank});
                    });
                }
            });

            return {
                G,
                TR,
                PO,
                addNewFilter,
                removeNewFilter,
                removeFilter,
                onEnd,
            };
        },
    };
</script>


<style lang="scss">
    .filter_list{
        .p-dropdown{
            width: 12rem;
        }
        .p-inputnumber-input{
            width: 100% !important;
        }
    }
</style>

